export const Add = () => {
    return (
        <svg className={"add-icon"} width="16" height="16" viewBox="0 0 16 16">
            <path
                d="M247.333-711.333H240v-1.333h7.333V-720h1.333v7.333H256v1.333h-7.333V-704h-1.333Z"
                transform="translate(-240 720)"
            />
        </svg>
    );
};
